<template>
  <svg
    width="28px"
    height="24px"
    viewBox="0 0 28 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Home-1"
        transform="translate(-1851.000000, -98.000000)"
        fill="#000000"
        fill-rule="nonzero"
        stroke="#000000"
        stroke-width="0.5"
      >
        <g id="Nav" transform="translate(40.000000, 98.000000)">
          <g id="Group-5" transform="translate(1682.000000, 0.000000)">
            <path
              d="M135.61,3.53846154 L134.865385,1 L130,1 L130,2.69230769 L133.596154,2.69230769 L137.378462,15.5538462 C137.644138,16.454726 138.469997,17.0741197 139.409231,17.0769231 L151.822308,17.0769231 C152.823337,17.0698822 153.683546,16.3647925 153.886923,15.3846154 L156.425385,3.53846154 L135.61,3.53846154 Z M152.236923,15.0461538 C152.196708,15.2431665 152.023383,15.3846154 151.822308,15.3846154 L139.409231,15.3846154 C139.221197,15.3846154 139.055726,15.2605128 139.003077,15.08 L136.109231,5.23076923 L154.335385,5.23076923 L152.236923,15.0461538 Z M141.846154,20.8846154 C141.846154,22.05291 140.899064,23 139.730769,23 C138.562475,23 137.615385,22.05291 137.615385,20.8846154 C137.615385,19.7163207 138.562475,18.7692308 139.730769,18.7692308 C140.899064,18.7692308 141.846154,19.7163207 141.846154,20.8846154 L141.846154,20.8846154 Z M153.692308,20.8846154 C153.692308,22.05291 152.745218,23 151.576923,23 C150.408628,23 149.461538,22.05291 149.461538,20.8846154 C149.461538,19.7163207 150.408628,18.7692308 151.576923,18.7692308 C152.745218,18.7692308 153.692308,19.7163207 153.692308,20.8846154 L153.692308,20.8846154 Z"
              id="Cart"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "icon-cart",
};
</script>

<style scoped lang="scss">
path {
  transition: fill 0.3s ease;
}
.theme-dark svg {
  path {
    fill: #ffffff;
  }
  &:hover {
    path {
      fill: #666;
    }
  }
}

.theme-light svg {
  path {
    fill: #000000;
  }
  &:hover {
    path {
      fill: #666;
    }
  }
}
</style>
